import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Footer.css"; // Import CSS for styling

const Footer = () => {
  return (
    <footer className="Footer ">
      <Container className="Footer-bottom">
        <Row>
          <Col
            md={3}
            sm={6}
            xs={12}
            className="Footer-section"
            style={{ paddingLeft: "30px" }}
          >
            <h5>Facility 1</h5>
            <ul>
              <li>106, Sindhu Plaza</li>
              <li>100 feet Road</li>
              <li>Mudaliarpet</li>
              <li>Pondicherry</li>
              <li>605004</li>
            </ul>
            <h5>US Office</h5>

            <ul>
              <li>8, The Green Suite B</li>
              <li>Dover</li>
              <li>DE 19901</li>
              <li style={{ marginTop: "10px" }}>Phone : +1(512)6416014</li>
              <li>Email: enquiry@myrtlercm.com</li>
            </ul>
          </Col>
          <Col md={3} sm={6} xs={12} className="Footer-section">
            <h5>Facility 2</h5>
            <ul>
              <li>H.NO:7-1-395/5</li>
              <li>Near SBI Bank</li>
              <li>4th floor, JSP Honda Showroom Building</li>
              <li>Balkampet Road</li>
              <li>SR Nagar</li>
              <li>Hyderabad</li>
              <li>500016</li>
            </ul>
          </Col>
          <Col md={3} sm={6} xs={12} className="Footer-section">
            <h5>Who we serve</h5>
            <ul>
              <li>Individual physicians</li>
              <li>Therapists </li>
              <li>DME suppliers </li>
              <li>Ambulatory Surgery Centers </li>
              <li>Ambulance </li>
              <li>Acute Care Hospitals</li>
              <li>Radiology centers </li>
              <li>Hospice </li>
              <li>Renal Dialysis Centers </li>
              <li>FQHC</li>
            </ul>
          </Col>
          <Col md={3} sm={6} xs={12} className="Footer-section">
            <h5>Services offered</h5>
            <ul>
              <li>Front end Billing services</li>
              <li>Coding & Compliance</li>
              <li>Backend RCM services</li>
              <li>Credentialing & Provider Enrollment</li>
              <li>Insurance & Patient Services</li>
              <li>Specialty focused end to end Medical Billing Services</li>
              <li>Telemedicine Billing Services</li>
              <li>Technology & Software Support</li>
            </ul>
          </Col>
        </Row>
      </Container>
      <div className="Footer-divider"></div>

      <Container className="Footer-bottom">
        <Row className="Footer-bottom-row">
          <Col md={6} className="Footer-left">
            <p>
              Myrtle RCM, One Click at a Time | © 2025. All Rights Reserved{" "}
            </p>
          </Col>
          <Col md={6} className="Footer-right text-md-end">
            <p>
              Crafted by ⚙️ &nbsp;
              <a
                href="https://dremerz.net"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "white" }}
              >
                Dremerz Consultancy and Services
              </a>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
